var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "anchor-bar__bar", class: [{ stuck: _vm.isStuck }] },
    [
      _c("div", { staticClass: "anchor-bar__dropdown" }, [
        _c(
          "label",
          {
            staticClass: "control__label sr-only",
            attrs: { for: "anchor-bar-select" },
          },
          [_vm._v(_vm._s(_vm.label))]
        ),
        _vm._v(" "),
        _c(
          "select",
          {
            staticClass: "anchor-bar__select",
            attrs: { id: "anchor-bar-select" },
            domProps: { value: _vm.formattedCurrentIndex },
            on: {
              change: function ($event) {
                return _vm.scrollTo(
                  _vm.targets[$event.target.value],
                  $event.target.value
                )
              },
            },
          },
          [
            _c("option", { attrs: { value: "null", disabled: "" } }, [
              _vm._v("\n        " + _vm._s(_vm.label) + "\n      "),
            ]),
            _vm._v(" "),
            _vm._l(_vm.targets, function (target, index) {
              return _c(
                "option",
                { key: target.id, domProps: { value: index } },
                [
                  _vm._v(
                    "\n        " + _vm._s(target.dataset.anchor) + "\n      "
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "anchor-bar__grid" }, [
        _c(
          "ul",
          { staticClass: "anchor-bar__list" },
          _vm._l(_vm.targets, function (target, index) {
            return _c("li", { key: target.id }, [
              _c(
                "a",
                {
                  staticClass: "anchor-bar__link",
                  class: {
                    "anchor-bar__link--active": index === _vm.currentIndex,
                  },
                  attrs: { href: "#" + target.id },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.scrollTo(target, index)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(target.dataset.anchor) +
                      "\n        "
                  ),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }